import api from './axios';

// Veli tarafı
export const getUpcomingSessions = (studentId) => api.get(`/parent/students/${studentId}/upcoming-sessions`);
export const getMakeupSlotOptions = (studentId) => api.get(`/parent/students/${studentId}/makeup-slot-options`);
export const createParentRequest = (data) => api.post('/parent/requests', data);
export const getMyParentRequests = (params) => api.get('/parent/requests', { params });
export const cancelParentRequest = (id) => api.delete(`/parent/requests/${id}`);

// Personel tarafı
export const getParentRequests = (params) => api.get('/parent-requests', { params });
export const decideParentRequest = (id, data) => api.patch(`/parent-requests/${id}/decide`, data);
